<script lang="ts" setup>
import type { MessageJumpVo } from '@core/types/auto/forum';
import type { MessageToken } from '@core/utils/message';

const emit = defineEmits<{
  (e: 'inline-click', jump: MessageJumpVo): void;
}>();

defineProps<{
  tokens: MessageToken[];
}>();
</script>

<template>
  <template v-for="(token, idx) in tokens" :key="idx">
    <span v-if="token.type === 'text'">{{ token.text }}</span>
    <span
      v-else
      class="text-primary cursor-pointer hover:opacity-75"
      @click.stop="emit('inline-click', token.jump)"
      >{{ token.text }}</span
    >
  </template>
</template>
